import React from "react";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import AppInput from "components/Input/AppInput";
import { FormGroup, Grid, makeStyles } from "@material-ui/core";
import { YupValidations } from "utils/validate";
import AppColor from "utilities/AppColor";
import AppButton from "components/CustomButtons/AppButton";
import AppConfig from "config/AppConfig";
import PasswordStrength from "components/Progress/PasswordStrength";
import md5 from 'md5';
import { useParams } from "react-router";

const { PATTERNS } = AppConfig;

const ChangePasswordForm = (props) => {
  const {
    onSubmit,
    isSubmitting,
    formRef
  } = props;

  const { t } = useTranslation();
  const { id } = useParams();

  const initForm = {
    password: '',
    confirmPassword: '',
  };

  const handleSubmitForm = (form, formikBag) => {
    const { confirmPassword, password } = form;
    const params = {};

    if (confirmPassword && confirmPassword !== '') {
      params['confirmPass'] = md5(confirmPassword);
    }
    if (password && password !== '') {
      params['newPass'] = md5(password);
    }
    if (id) {
      params['id'] = id;
    }
    onSubmit(params);
    formikBag.resetForm();
  };
  const styles = makeStyles(() => ({
    title: {
      display: 'flex',
      margin: '2rem 0 1rem 0',
      '& h5': {
        color: AppColor.mainColor,
      }
    },
    control: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
      justifyContent: 'flex-end'
    },
    subLabel: {
      marginBottom: '0.5rem',
      fontSize: '0.8rem'
    }
  }));
  const classes = styles();

  const validationSchema = Yup.object().shape({
    password: YupValidations.password
      .max(32, "validation.max_length_32")
      .matches(PATTERNS.PASSWORD_LOWER, {
        message: "validation.password.lowercase"
      })
      .matches(PATTERNS.PASSWORD_UPPER, {
        message: "validation.password.uppercase"
      })
      .matches(PATTERNS.PASSWORD_NUMBER, {
        message: "validation.password.number"
      })
      .matches(PATTERNS.PASSWORD_PATTERN, {
        message: "validation.password.minLength"
      })
      .test('password', 'validation.password.spaces', (value) => {
        if (value && value.includes(' ')) {
          return false;
        } else {
          return true;
        }
      }),
    confirmPassword: Yup.string().when("password",
      (password) => {
        return password && password !== '' ? YupValidations.requiredString
          .oneOf([Yup.ref("password")], "validation.confirmPassword.mismatch") : Yup.string().notRequired()
          .test('confirmPassword', 'validation.confirmPassword.spaces', (value) => {
            if (value && value.includes(' ')) {
              return false;
            } else {
              return true;
            }
          });
      })
  });
  return (
    <Formik
      enableReinitialize={true}
      onSubmit={handleSubmitForm}
      initialValues={initForm}
      validationSchema={validationSchema}
      innerRef={formRef}
    >
      {({ values, errors }) => {
        return (
          <Form>
            {/* <Box className={classes.subLabel}>
              {t('text.leavePasswordBlank')}
            </Box> */}
            <Field
              component={AppInput}
              name="password"
              type="password"
              label={"label.password"}
              errorMessage={!!errors['password']}
              isTouched={!!errors['password']}
              required
              strongLabel
            />
            {
              values.password && values.password !== '' && (
                <React.Fragment>
                  <Grid container>
                    <Grid item xs={12} sm={6} md={6}>
                      <PasswordStrength
                        value={values.password}
                        label={`${t('label.strength')}:`}
                      />
                    </Grid>
                  </Grid>
                </React.Fragment>
              )
            }
            <Field
              component={AppInput}
              name="confirmPassword"
              type="password"
              label={"label.reEnterPassword"}
              required
              strongLabel
            />
            <FormGroup className={classes.control}>
              <AppButton
                label={`${t("button.save")}`}
                rounder
                type="submit"
                isLoading={isSubmitting}
                disabled={isSubmitting}
              />
            </FormGroup>
          </Form>
        );
      }}
    </Formik >
  );
};

ChangePasswordForm.propTypes = {
  onSubmit: PropTypes.func,
  formRef: PropTypes.any,
  isSubmitting: PropTypes.bool
};

export default ChangePasswordForm;
